export const ADMIN_SHIPPING_PROVIDER_LIST_TAB = {
  field: 'is_active',
  multiSelect: false,
  tabs: [
    { key: 'Active', label: 'Active', value: 'true' },
    { key: 'Inactive', label: 'Inactive', value: 'false' },
  ],
};
